module.exports = __webpack_public_path__ + "img/yhtejia.a5987d02.svg";